import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CanvasesCategoriesTest } from '../../pages/canvases/categories/Test';
import { useDemoContext } from '../../contexts/DemoContext';
import '../styles/demo.css';

export function DemoCanvas() {
  const navigate = useNavigate();
  const { updateDemoPhase, demoData, updateDemoData } = useDemoContext();
  const [showSaveNotification, setShowSaveNotification] = useState(false);
  const [isConversationCompleted, setIsConversationCompleted] = useState(false);
  
  const handleSaveAndFinish = () => {
    setIsConversationCompleted(true);
    
    updateDemoPhase('conversation-complete');
    
    if (demoData.completedConversations && demoData.completedConversations.length > 0) {
      const mostRecentConversation = [...demoData.completedConversations].sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      })[0];
      
      if (mostRecentConversation) {
        const updatedCompletedConversations = demoData.completedConversations.map(conversation => {
          if (conversation.id === mostRecentConversation.id) {
            return {
              ...conversation,
              status: 2,
              updatedAt: new Date().toISOString()
            };
          }
          return conversation;
        });
        
        updateDemoData({
          ...demoData,
          completedConversations: updatedCompletedConversations
        });
      }
    }
    
    setShowSaveNotification(true);
    
    setTimeout(() => {
      setShowSaveNotification(false);
    }, 8000);
  };

  const handleBack = () => {
    navigate('/demo/conversations');
  };

  useEffect(() => {
    const injectDemoButtons = () => {
      const headerRightCell = document.querySelector('.page-content__header--fixed .text-right');
      
      if (headerRightCell && !headerRightCell.querySelector('.demo-save-buttons')) {
        headerRightCell.innerHTML = '';
        
        const demoButtonsContainer = document.createElement('div');
        demoButtonsContainer.className = 'demo-save-buttons';
        
        if (!isConversationCompleted) {
          const saveForLaterBtn = document.createElement('button');
          saveForLaterBtn.className = 'page-content__button--medium page-content__button--back';
          saveForLaterBtn.innerHTML = 'Save for later ⬇';
          
          const saveAndFinishBtn = document.createElement('button');
          saveAndFinishBtn.className = 'page-content__button--medium page-content__button--primary';
          saveAndFinishBtn.innerHTML = 'Save and finish ✓';
          saveAndFinishBtn.onclick = handleSaveAndFinish;
          
          demoButtonsContainer.appendChild(saveForLaterBtn);
          demoButtonsContainer.appendChild(saveAndFinishBtn);
        } else {
          const completedMessage = document.createElement('div');
          completedMessage.className = 'demo-completed-message';
          completedMessage.innerHTML = '<strong>✓ Conversation Completed</strong>';
          completedMessage.style.color = 'var(--color--brand-secondary);';
          completedMessage.style.fontSize = '16px';
          completedMessage.style.fontWeight = 'bold';
          demoButtonsContainer.appendChild(completedMessage);
        }
        
        const backButton = document.querySelector('#page-navigation-button--go-back');
        if (backButton) {
          backButton.href = '#';
          backButton.onclick = (e) => {
            e.preventDefault();
            handleBack();
          };
        }
        
        headerRightCell.appendChild(demoButtonsContainer);
      }
    };

    const injectCompletedState = () => {
      if (isConversationCompleted) {
        const reactFlowElement = document.querySelector('.react-flow');
        if (reactFlowElement) {
          reactFlowElement.style.pointerEvents = 'none';
          reactFlowElement.classList.add('canvas-disabled');
        }

        const nodes = document.querySelectorAll('.react-flow__node');
        nodes.forEach(node => {
          node.style.pointerEvents = 'none';
          node.style.cursor = 'not-allowed';
          node.classList.add('node-disabled');
          
          const nodeInputs = node.querySelectorAll('input[type="text"], textarea, input[contenteditable], [contenteditable]');
          nodeInputs.forEach(input => {
            if (input.tagName.toLowerCase() === 'input' || input.tagName.toLowerCase() === 'textarea') {
              input.readOnly = true;
              input.style.backgroundColor = '#e9ecef';
              input.style.color = '#212529';
              input.style.cursor = 'not-allowed';
            } else if (input.hasAttribute('contenteditable')) {
              input.setAttribute('contenteditable', 'false');
              input.style.backgroundColor = '#e9ecef';
              input.style.color = '#212529';
              input.style.cursor = 'not-allowed';
            }
          });
        });

        const edges = document.querySelectorAll('.react-flow__edge');
        edges.forEach(edge => {
          edge.style.pointerEvents = 'none';
          edge.classList.add('edge-disabled');
        });

        const handles = document.querySelectorAll('.react-flow__handle');
        handles.forEach(handle => {
          handle.style.pointerEvents = 'none';
        });

        // Disable controls (zoom, pan controls)
        const controls = document.querySelectorAll('.react-flow__controls');
        controls.forEach(control => {
          control.style.pointerEvents = 'none';
          control.classList.add('controls-disabled');
        });

        // Disable minimap if present
        const minimap = document.querySelectorAll('.react-flow__minimap');
        minimap.forEach(map => {
          map.style.pointerEvents = 'none';
          map.classList.add('minimap-disabled');
        });

        // Disable all textareas and make them readonly
        const textareas = document.querySelectorAll('.canvas-category-controls-and-actions-section-item__input');
        textareas.forEach(textarea => {
          textarea.readOnly = true;
          textarea.style.backgroundColor = '#e9ecef';
          textarea.style.color = '#212529';
          textarea.style.cursor = 'not-allowed';
        });

        // Hide all add buttons
        const addButtons = document.querySelectorAll('.canvas-category-controls-and-actions-section-button');
        addButtons.forEach(button => {
          button.style.display = 'none';
        });

        // Hide all delete buttons
        const deleteButtons = document.querySelectorAll('.canvas-category-controls-and-actions-section-item__delete-button');
        deleteButtons.forEach(button => {
          button.style.display = 'none';
        });

        // Add checkboxes to action sections in the title header
        const actionTitles = document.querySelectorAll('.canvas-category-controls-and-actions-section-item__title--action');
        actionTitles.forEach((title, index) => {
          // Check if checkbox already exists
          if (!title.querySelector('.custom-checkbox')) {
            title.style.display = 'flex';
            title.style.alignItems = 'center';
            title.style.justifyContent = 'space-between';

            // Find the existing info icon
            const existingIcon = title.querySelector('.canvas-category-action-header-info-icon');
            
            // Create the left side with "Actions" text and info icon
            const leftContainer = document.createElement('div');
            leftContainer.style.display = 'flex';
            leftContainer.style.alignItems = 'center';
            leftContainer.style.gap = '8px';
            
            // Add "Actions" text
            const actionsText = document.createElement('span');
            actionsText.textContent = 'Actions ';
            actionsText.style.color = 'white';
            leftContainer.appendChild(actionsText);
            
            // Move the info icon next to the text (if it exists)
            if (existingIcon) {
              leftContainer.appendChild(existingIcon);
            }

            // Create checkbox container for the right side
            const checkboxContainer = document.createElement('div');
            checkboxContainer.style.display = 'flex';
            checkboxContainer.style.alignItems = 'center';
            checkboxContainer.style.gap = '8px';

            // Create checkbox label
            const checkboxLabel = document.createElement('label');
            checkboxLabel.className = 'custom-checkbox canvas-actions-checkbox';

            // Create checkbox input
            const checkboxInput = document.createElement('input');
            checkboxInput.className = 'basic-form__input';
            checkboxInput.type = 'checkbox';
            checkboxInput.id = `demo-checkbox-action-${index}`;
            checkboxInput.name = `demo-checkbox-action-${index}`;

            // Create checkmark span
            const checkmarkSpan = document.createElement('span');
            checkmarkSpan.className = 'checkmark';

            // Assemble checkbox
            checkboxLabel.appendChild(checkboxInput);
            checkboxLabel.appendChild(checkmarkSpan);
            checkboxContainer.appendChild(checkboxLabel);

            // Clear the title and add the new structure
            title.innerHTML = '';
            title.appendChild(leftContainer);
            title.appendChild(checkboxContainer);
          }
        });

        // Update instructions text
        const instructionsElement = document.querySelector('.canvas-category-controls-and-actions .canvas-category-controls-and-actions-header + .canvas-category-controls-and-actions-section-wrap p');
        if (instructionsElement) {
          instructionsElement.textContent = 'Here are some instructions for what to do with the action checkboxes';
        }

        // Hide the "Add controls and actions" footer button
        const footerButton = document.querySelector('.canvas-category-footer-wrap');
        if (footerButton) {
          footerButton.style.display = 'none';
        }
      } else {
        // When conversation is NOT completed, ensure ReactFlow elements are enabled
        const reactFlowElement = document.querySelector('.react-flow');
        if (reactFlowElement) {
          reactFlowElement.style.pointerEvents = '';
          reactFlowElement.classList.remove('canvas-disabled');
        }

        // Re-enable all nodes
        const nodes = document.querySelectorAll('.react-flow__node');
        nodes.forEach(node => {
          node.style.pointerEvents = '';
          node.style.cursor = '';
          node.classList.remove('node-disabled');
        });

        // Re-enable all edges
        const edges = document.querySelectorAll('.react-flow__edge');
        edges.forEach(edge => {
          edge.style.pointerEvents = '';
          edge.classList.remove('edge-disabled');
        });

        // Re-enable node handles
        const handles = document.querySelectorAll('.react-flow__handle');
        handles.forEach(handle => {
          handle.style.pointerEvents = '';
        });

        // Re-enable controls
        const controls = document.querySelectorAll('.react-flow__controls');
        controls.forEach(control => {
          control.style.pointerEvents = '';
          control.classList.remove('controls-disabled');
        });

        // Re-enable minimap
        const minimap = document.querySelectorAll('.react-flow__minimap');
        minimap.forEach(map => {
          map.style.pointerEvents = '';
          map.classList.remove('minimap-disabled');
        });
      }
    };

    // Try to inject buttons after the canvas has mounted
    const timer = setTimeout(() => {
      injectDemoButtons();
      injectCompletedState();
    }, 500);
    
    // Also set up a mutation observer to inject buttons if the canvas re-renders
    const observer = new MutationObserver(() => {
      // Re-inject buttons after DOM changes with a small delay
      setTimeout(() => {
        injectDemoButtons();
        injectCompletedState();
      }, 100);
    });
    
    // Observe the page content area for changes
    const waitForPageContent = () => {
      const pageContent = document.querySelector('.page-content');
      if (pageContent) {
        observer.observe(pageContent, { childList: true, subtree: true });
      } else {
        // If page content isn't ready yet, try again in a bit
        setTimeout(waitForPageContent, 100);
      }
    };
    
    waitForPageContent();
    
    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [isConversationCompleted]);

  return (
    <div className="demo-canvas-wrapper">
      {/* Save Complete Notification Banner (matches production style) */}
      {showSaveNotification && (
        <div className="save-notification">
          <div className="save-notification-content">
            <h3>Save Complete</h3>
            <p>This canvas has now been saved. You can now close this page safely and return to this canvas later.</p>
          </div>
          <button 
            className="save-notification-close" 
            onClick={() => setShowSaveNotification(false)}
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
      )}

      {/* Canvas Content */}
      <CanvasesCategoriesTest 
        isDemo={true} 
        submissionUnlocked={!isConversationCompleted}
      />
    </div>
  );
}
